export default {
    SET_LOADING_STATE: "workTypes/SET_LOADING_STATE",
    SET_WORK_TYPES_DATA: "workTypes/SET_WORK_TYPES_DATA",
    SET_DIALOG_STATE: "workTypes/SET_DIALOG_STATE"
} 